/** JPEG quality for live capture and landscape rotation (BMT-361). */
export const CAPTURE_JPEG_QUALITY = 0.92;

/** Original square stream — changing ideal resolution breaks localization. */
export const getCameraVideoConstraints = (): MediaTrackConstraints => ({
  width: { ideal: 720 },
  height: { ideal: 720 },
  facingMode: { ideal: "environment" },
  frameRate: { max: 12 },
});
